<main>
  <router-outlet></router-outlet>
</main>
